import { CatalogueType } from '@/scopes/common/domain/enums/CatalogueType'

export function getCatalogueTypeByPublicationCode(publicationCode: string): CatalogueType {
  const summerCodes = ['SZ', 'FZ', 'KZ', 'QZ', 'BZ', 'FS']
  const winterCodes = ['WG', 'DW', 'FW', 'KW', 'UW', 'QW', 'BW', 'FH']

  if (summerCodes.includes(publicationCode)) {
    return CatalogueType.Summer
  }
  if (winterCodes.includes(publicationCode)) {
    return CatalogueType.Winter
  }
  return CatalogueType.None
}
